import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "cim_impact_type",
})
export class CimImpactTypePipe implements PipeTransform {
  transform(value: string): string {
    // transform 'Resilience_loss' to 'Resilience loss'
    return value.replace("_", " ");
  }
}
